<template>
    <div class="screen" >   
          <div class="header">   
              <mhead :shopList="shoplist" @changeShop='changeShop' :openShops="openShops" :title="$route.meta.title"/>
          </div>
           <div class="content"> 
                <router-view />
           </div>
    </div>
</template>
<script>
import mhead from "@/components/cuscom/mhead"
export default {
     provide () {
        return {
            mainRoot: this
        };
     },
     data(){
         return {
             openShops:false,
             shopId:'0',
             shoplist:[{storeName:"",channelId:"1"}]
         }
     },
   components:{
       mhead
   },
   methods:{
     changeShop(shop){
      this.shopId=shop.channelId
      this.$router.push({
          name:'bigop',
          params:{
              id:shop.channelId
          }
      })
     }
   }
}
</script>
<style lang="scss" scoped>

 *{
    box-sizing: border-box;
  } 

 .screen{           
    background-size: 100% 100%;
    background-image: url(../../assets/bg.png);
    flex-direction: column;
    height: 100%;
    display: flex;
    .header{
           height: 80px;
           
       }
    .content{
            flex:1;
            padding: 8px 10px;   
      
          
       }
  }
</style>